import { createFileRoute } from "@tanstack/react-router";
import { AgendaCriarPage } from "@/paginas/pg_agenda/agenda-criar";

export const Route = createFileRoute("/_authenticated/agenda-criar")({
  head: () => ({
    meta: [
      { title: "Agenda — Criar — Milky Moo Palmares" },
      { name: "description", content: "Criar evento na agenda." },
    ],
  }),
  component: AgendaCriarPage,
});
